import * as type from '../actions/types';

const initialState = {
  eventsCalendar: null,
  loading: false,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_EVENTS_CALENDAR_PENDING:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case type.FETCH_EVENTS_CALENDAR_SUCCESS:
      return {
        ...state,
        eventsCalendar: action.payload,
        loading: false,
        error: null,
      };

    case type.FETCH_EVENTS_CALENDAR_FAILURE:
      return {
        ...state,
        eventsCalendar: null,
        loading: false,
        error: action.payload,
      };

    case type.RESET_EVENTS_CALENDAR:
      return {
        ...state,
        eventsCalendar: null,
        loading: true,
        error: null,
      };

    default:
      return state;
  }
};
